export const HEALTH_STATUS = {
  Healthy: 'Healthy',
  ConfigIssue: 'ConfigIssue',
  Offline: 'Offline',
};

const HEALTH_STATUS_MAPPING = [
  { value: HEALTH_STATUS.Healthy, label: 'Healthy', color: '#7DFF92' },
  { value: HEALTH_STATUS.ConfigIssue, label: 'Config Issue', color: '#FFB547' },
  { value: HEALTH_STATUS.Offline, label: 'Offline', color: '#FF7B72' },
];

export const getHealthStatusLabel = value =>
  HEALTH_STATUS_MAPPING.find(item => item.value === value)?.label || 'Offline';

export const getHealthStatusColor = value =>
  HEALTH_STATUS_MAPPING.find(item => item.value === value)?.color || '#FF7B72';
